import { Element } from 'react-bulma-components';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';
import styles from './cancel-alert-modal.module.scss';

export type CancelAlertModalProps = {
  show: boolean;
  title: string;
  subtitle: string;
  onCancel: () => void;
  onClose: () => void;
};

export function CancelAlertModal({
  show,
  title,
  subtitle,
  onCancel,
  onClose,
}: CancelAlertModalProps) {
  return (
    <Modal show={show} title={title} titleClassName="mb-4">
      <p className={styles.subtitleContainer}>{subtitle}</p>
      <Element
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={8}
      >
        <Button color="primary-dark" outlined onClick={onClose}>
          No, continue
        </Button>
        <Button color="danger-dark" onClick={onCancel}>
          Yes, cancel
        </Button>
      </Element>
    </Modal>
  );
}

export default CancelAlertModal;
